<template>
  <div class="landing-wrapper">
    <div class="stage-floor"></div>

    <v-container class="landing-main landing-main-home px-4 px-sm-6 px-md-10 py-8 py-md-12" fluid>
      <template v-if="!selectedGenre">
        <div class="landing-logo">
          <img
            class="logo-main-img"
            src="/static/img/logo_ppal.png"
            alt="Logo Somos Teatro"
          />
        </div>
        <p class="landing-subtitle">
          SELECCIONA EL GÉNERO Y LA OBRA QUE DESEAS CONTRATAR
        </p>

        <v-row class="genre-cards ma-0" justify="center" align="stretch">
          <v-col
            v-for="genre in genres"
            :key="genre.name"
            cols="6"
            sm="4"
            md="3"
            lg="2"
            class="genre-col"
          >
              <div
                class="genre-card"
                @click="openGenre(genre)"
              >
                <v-img
                  :src="genre.image"
                  :alt="genre.name"
                  cover
                  class="genre-image"
                />
              </div>
          </v-col>
        </v-row>
      </template>

      <template v-else>
        <div class="genre-view">
          <div class="genre-view-head">
            <h2 class="genre-view-title">{{ selectedGenre.name }}</h2>
          </div>

          <div class="genre-view-carousel">
            <v-btn
              class="arrow-btn"
              icon
              size="small"
              variant="tonal"
              aria-label="Anterior"
              :disabled="carouselPage === 0"
              @click="prevPage"
            >
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>

            <div
              ref="carouselWindow"
              class="show-grid"
              :style="{ '--items-per-page': itemsPerPage, '--show-count': selectedShows.length }"
              @touchstart.passive="handleTouchStart"
              @touchend="handleTouchEnd"
            >
              <div class="show-track" :style="carouselTrackStyle">
                <article
                  v-for="show in selectedShows"
                  :key="show.id"
                  class="show-card"
                  @click="openShow(show)"
                >
                  <div class="show-card-content">
                    <h3 class="show-title">{{ show.title }}</h3>
                    <img :src="show.image" :alt="show.title" class="show-avatar" />
                    <p class="show-description">{{ show.description }}</p>
                    <div class="details-btn-wrap">
                      <v-btn
                        class="details-btn"
                        color="red-darken-3"
                        rounded="lg"
                        size="default"
                        block
                        @click.stop="openShow(show)"
                      >
                        MÁS DETALLES
                      </v-btn>
                    </div>
                  </div>
                </article>
              </div>
            </div>

            <v-btn
              class="arrow-btn"
              icon
              size="small"
              variant="tonal"
              aria-label="Siguiente"
              :disabled="carouselPage >= pageCount - 1"
              @click="nextPage"
            >
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </div>

          <v-btn class="back-link" variant="text" prepend-icon="mdi-undo" @click="backToGenres">VOLVER</v-btn>
        </div>
      </template>
    </v-container>

    <teatro-footer />
  </div>
</template>

<script>
import { genres as fallbackGenres, genreShows as fallbackGenreShows } from "./teatroData";
import { fetchLanding } from "@/services/teatroApi";

export default {
  name: "LandingTeatro",
  data() {
    return {
      selectedGenre: null,
      genres: [],
      genreShows: {},
      loading: true,
      carouselPage: 0,
      itemsPerPage: 4,
      windowWidth: 0,
      touchStartX: 0,
    };
  },
  computed: {
    selectedShows() {
      return this.genreShows[this.selectedGenre?.name] || this.genreShows.COMEDIA || [];
    },
    pageCount() {
      return Math.max(1, Math.ceil(this.selectedShows.length / this.itemsPerPage));
    },
    carouselTrackStyle() {
      return {
        transform: `translateX(-${this.carouselPage * this.windowWidth}px)`,
      };
    },
  },
  mounted() {
    this.updateItemsPerPage();
    window.addEventListener("resize", this.updateItemsPerPage);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.updateItemsPerPage);
  },
  async created() {
    try {
      const { genres, genreShows } = await fetchLanding();
      this.genres = genres;
      this.genreShows = genreShows;
    } catch (e) {
      // Fallback a los datos locales si el backend aún no está disponible.
      console.error("No se pudo cargar desde el backend, usando datos locales:", e);
      this.genres = fallbackGenres;
      this.genreShows = fallbackGenreShows;
    } finally {
      this.loading = false;
    }
  },
  methods: {
    openGenre(genre) {
      this.selectedGenre = genre;
      this.carouselPage = 0;
      this.$nextTick(() => this.updateWindowWidth());
    },
    openShow(show) {
      // El detalle de la obra vive en su propia URL / componente.
      window.location.href = `/obra/${show.id}/`;
    },
    backToGenres() {
      this.selectedGenre = null;
      this.carouselPage = 0;
    },
    getSelectedShows() {
      return this.selectedShows;
    },
    updateItemsPerPage() {
      const width = window.innerWidth;
      if (width < 600) {
        this.itemsPerPage = 1;
      } else if (width < 960) {
        this.itemsPerPage = 2;
      } else {
        this.itemsPerPage = 4;
      }
      this.updateWindowWidth();
    },
    updateWindowWidth() {
      this.windowWidth = this.$refs.carouselWindow?.clientWidth || window.innerWidth;
    },
    prevPage() {
      if (this.carouselPage > 0) this.carouselPage -= 1;
    },
    nextPage() {
      if (this.carouselPage < this.pageCount - 1) this.carouselPage += 1;
    },
    handleTouchStart(event) {
      this.touchStartX = event.changedTouches[0].screenX;
    },
    handleTouchEnd(event) {
      const endX = event.changedTouches[0].screenX;
      const diff = this.touchStartX - endX;
      if (Math.abs(diff) > 40) {
        if (diff > 0) this.nextPage();
        else this.prevPage();
      }
    },
  },
};
</script>
